import { render, staticRenderFns } from "./vsDropDown.vue?vue&type=template&id=f2f01fe0&lang=html&"
import script from "./vsDropDown.vue?vue&type=script&lang=js&"
export * from "./vsDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vsDropDown.vue"
export default component.exports